import axios from '../../../axios';
import IClientCurrency from '../types/IClientCurrencySettings';
import IUpdateStatus from '../types/IUpdateStatus';

const url = 'invoicingservice/api/';

export const getAllClientCurrencies = () => axios.get(`${url}client-currencies`);

export const getAllActiveCurrenciesByWorkspaceId = () =>
  axios.get(`${url}currencies/active/current-workspace`);

export const createNewCurrency = (clientCurrency: IClientCurrency) =>
  axios.post(`${url}create-currency`, clientCurrency);

export const updateCurrency = (clientCurrency: IClientCurrency) =>
  axios.put(`${url}update-currencies`, clientCurrency);

export const updateCurrencyStatus = (id: string, status: IUpdateStatus) =>
  axios.put(`${url}currencies/update-status/${id}`, status);

export const getCurrencyById = (id: string) => axios.get(`${url}currencies/${id}`);

export const updateCurrencyDefault = (id: string) =>
  axios.post(`${url}currencies/update-default/${id}`);

export const getDefaultCurrency = () => axios.get(`${url}default-client-currencies`);
